// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.billfileContainer {
    background-color: #EFF3F8;
    height: 90vh;
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: none;
    scroll-behavior: smooth;

    .billtableContainer {
        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.144);
        width: 94%;
        padding: 40px 40px;
        background-color: white;
        border-radius: 10px;
        overflow: hidden;
        justify-content: center;



        .tableContainer {
            width: 100%;
            display: flex;
            justify-content: center;
            display: flex;
            justify-content: center;
            align-items: center;

            table {
                border-collapse: collapse;
                tr{
                    border: 1px solid #2C78DB;
                }

                thead {
                    tr {
                        background-color: #2C78DB;

                        th {
                            font-size: 14px;
                            font-weight: 600;
                        }
                    }
                }

                tbody {
                    tr {

                        td {
                            font-size: 13px;
                            font-weight: 600;
                            padding: 7px 0px;
                        }
                    }
                }

            }
        }
    }

}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/Master/BillFiles/billfiles.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,uBAAuB;;IAEvB;QACI,gDAAgD;QAChD,UAAU;QACV,kBAAkB;QAClB,uBAAuB;QACvB,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;;;;QAIvB;YACI,WAAW;YACX,aAAa;YACb,uBAAuB;YACvB,aAAa;YACb,uBAAuB;YACvB,mBAAmB;;YAEnB;gBACI,yBAAyB;gBACzB;oBACI,yBAAyB;gBAC7B;;gBAEA;oBACI;wBACI,yBAAyB;;wBAEzB;4BACI,eAAe;4BACf,gBAAgB;wBACpB;oBACJ;gBACJ;;gBAEA;oBACI;;wBAEI;4BACI,eAAe;4BACf,gBAAgB;4BAChB,gBAAgB;wBACpB;oBACJ;gBACJ;;YAEJ;QACJ;IACJ;;AAEJ","sourcesContent":[".billfileContainer {\n    background-color: #EFF3F8;\n    height: 90vh;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    scrollbar-width: none;\n    scroll-behavior: smooth;\n\n    .billtableContainer {\n        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.144);\n        width: 94%;\n        padding: 40px 40px;\n        background-color: white;\n        border-radius: 10px;\n        overflow: hidden;\n        justify-content: center;\n\n\n\n        .tableContainer {\n            width: 100%;\n            display: flex;\n            justify-content: center;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            table {\n                border-collapse: collapse;\n                tr{\n                    border: 1px solid #2C78DB;\n                }\n\n                thead {\n                    tr {\n                        background-color: #2C78DB;\n\n                        th {\n                            font-size: 14px;\n                            font-weight: 600;\n                        }\n                    }\n                }\n\n                tbody {\n                    tr {\n\n                        td {\n                            font-size: 13px;\n                            font-weight: 600;\n                            padding: 7px 0px;\n                        }\n                    }\n                }\n\n            }\n        }\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
